import React, { useMemo } from 'react';
import {
  AccountTypeIcon,
  BeakLargeIcon,
  BeakSmallIcon,
  Box,
  CardTypesEnum,
  Text,
} from '@common-fe/common-fe';
import styled from 'styled-components';

import { AccountOrder } from '@/modules/UseMyMoney/queries';
import { OcrAccountOrderOption } from '@/modules/UseMyMoney/UseMyMoney.types';
import colors from '@/styles/colors';
import formatCurrency from '@/utils/modifiers/formatCurrency';

import PaymentOrderBrickHint from './PaymentOrderBrickHint';

const Container = styled(Box)`
  position: relative;
`;

const BeakWrapper = styled(Box)`
  position: absolute;
  top: 0;
  right: -22px;
  pointer-events: none;
`;

const PaymentOrderBrickWrapper = styled(Box)`
  position: relative;
  border-radius: 6px 0px 0px 6px;
  border-right: none;
  z-index: 1;
`;

interface Props {
  order?: number;
  zIndex?: number;
  account?: OcrAccountOrderOption | AccountOrder;
  isMobile?: boolean;
  isSmall?: boolean;
}

const PaymentOrderBrick: React.FC<Props> = ({ order, zIndex, account, isMobile, isSmall }) => {
  const isFirstInRow = useMemo(() => !isMobile && order && order % 2 === 0, [order, isMobile]);

  return (
    <Container data-testId="payment-order_brick" style={{ zIndex: zIndex }}>
      <PaymentOrderBrickWrapper
        direction="row"
        align="center"
        background={isSmall ? 'module' : 'canvas'}
        border={{ size: '1.5px', color: 'border1' }}
        height={isSmall ? '40px' : '48px'}
        pad={{
          vertical: 'spacing8',
          left: isFirstInRow ? 'spacing32' : 'spacing24',
          right: 'spacing2'
        }}
      >
        <AccountTypeIcon
          type={account?.accountType as unknown as CardTypesEnum}
          color={colors.cardTypes?.[account?.accountType as unknown as CardTypesEnum]}
          size="24px"
        />
        <Text data-testId="payment-order_brick-title" margin={{ left: 'spacing8' }}>
          {order}
          {'. '}
          {account?.accountType}
          {' '}
          ({formatCurrency(account?.availableBalance || 0)})
        </Text>

        <Box margin={{ left: 'auto' }}>
          <PaymentOrderBrickHint
            accountType={account?.accountType}
            order={order}
          />
        </Box>
      </PaymentOrderBrickWrapper>

      <BeakWrapper>
        {isSmall ? <BeakSmallIcon size="40px" /> : <BeakLargeIcon size="48px" />}
      </BeakWrapper>
    </Container>
  );
};

export default PaymentOrderBrick;
